function NavSettingIcon({height, width, fill, color}) {
    return (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 6C17.1894 6 17.8136 6.27905 18.2659 6.73036C18.2834 6.74784 18.3007 6.76559 18.3177 6.78358C18.7174 7.20678 18.971 7.76953 18.9977 8.39107L18.9985 8.41205C18.9995 8.44124 19 8.47056 19 8.5V8.51426C19 8.55491 19.0247 8.59145 19.0623 8.60702C19.0998 8.62261 19.1431 8.61423 19.1719 8.58546L19.182 8.57538C19.2028 8.55456 19.2239 8.53419 19.2452 8.51426L19.2607 8.5C19.719 8.07934 20.2962 7.86073 20.8782 7.84417C20.9029 7.84346 20.9277 7.84312 20.9524 7.84315C21.5913 7.84382 22.23 8.0879 22.7175 8.57538L23.4246 9.28249C23.9121 9.76997 24.1562 10.4087 24.1569 11.0476C24.1569 11.0723 24.1565 11.0971 24.1558 11.1218C24.1393 11.7038 23.9207 12.281 23.5 12.7393L23.4857 12.7548C23.4658 12.7761 23.4454 12.7972 23.4246 12.818L23.4145 12.8281C23.3858 12.8569 23.3774 12.9002 23.393 12.9377C23.4085 12.9753 23.4451 13 23.4857 13H23.5C23.5294 13 23.5588 13.0005 23.5879 13.0015L23.6089 13.0023C24.2305 13.029 24.7932 13.2826 25.2164 13.6823C25.2344 13.6993 25.2522 13.7166 25.2696 13.7341C25.721 14.1864 26 14.8106 26 15.5V16.5C26 17.1894 25.721 17.8136 25.2696 18.2659C25.2522 18.2834 25.2344 18.3007 25.2164 18.3177C24.7932 18.7174 24.2305 18.971 23.6089 18.9977L23.5879 18.9985C23.5588 18.9995 23.5294 19 23.5 19H23.4857C23.4451 19 23.4085 19.0247 23.393 19.0623C23.3774 19.0998 23.3858 19.1431 23.4145 19.1719L23.4246 19.182C23.4454 19.2028 23.4658 19.2239 23.4857 19.2452L23.5 19.2607C23.9207 19.719 24.1393 20.2962 24.1558 20.8782C24.1565 20.9029 24.1569 20.9277 24.1569 20.9524C24.1562 21.5913 23.9121 22.23 23.4246 22.7175L22.7175 23.4246C22.23 23.9121 21.5913 24.1562 20.9524 24.1568C20.9277 24.1569 20.9029 24.1565 20.8782 24.1558C20.2963 24.1393 19.719 23.9207 19.2607 23.5L19.2452 23.4857C19.2239 23.4658 19.2028 23.4454 19.182 23.4246L19.1719 23.4145C19.1431 23.3858 19.0998 23.3774 19.0623 23.393C19.0247 23.4085 19 23.4451 19 23.4857V23.5C19 23.5294 18.9995 23.5588 18.9985 23.5879L18.9977 23.6089C18.971 24.2305 18.7174 24.7932 18.3177 25.2164C18.3007 25.2344 18.2834 25.2522 18.2659 25.2696C17.8136 25.7209 17.1894 26 16.5 26H15.5C14.8106 26 14.1864 25.7209 13.7341 25.2696C13.7166 25.2522 13.6993 25.2344 13.6823 25.2164C13.2826 24.7932 13.029 24.2305 13.0023 23.6089L13.0015 23.5879C13.0005 23.5588 13 23.5294 13 23.5V23.4857C13 23.4451 12.9753 23.4085 12.9377 23.393C12.9002 23.3774 12.8569 23.3858 12.8281 23.4145L12.818 23.4246C12.7972 23.4454 12.7761 23.4658 12.7548 23.4857L12.7393 23.5C12.281 23.9207 11.7037 24.1393 11.1218 24.1558C11.0971 24.1565 11.0723 24.1569 11.0476 24.1568C10.4087 24.1562 9.76997 23.9121 9.28249 23.4246L8.57538 22.7175C8.0879 22.23 7.84382 21.5913 7.84315 20.9524C7.84312 20.9277 7.84346 20.9029 7.84417 20.8782C7.86073 20.2962 8.07934 19.719 8.5 19.2607L8.51426 19.2452C8.53419 19.2239 8.55456 19.2028 8.57538 19.182L8.58546 19.1719C8.61423 19.1431 8.62261 19.0998 8.60702 19.0623C8.59145 19.0247 8.55491 19 8.51426 19H8.5C8.47056 19 8.44125 18.9995 8.41205 18.9985L8.39107 18.9977C7.76953 18.971 7.20678 18.7174 6.78358 18.3177C6.76558 18.3007 6.74784 18.2834 6.73036 18.2659C6.27905 17.8136 6 17.1894 6 16.5V15.5C6 14.8106 6.27905 14.1864 6.73036 13.7341C6.74784 13.7166 6.76558 13.6993 6.78358 13.6823C7.20678 13.2826 7.76953 13.029 8.39107 13.0023L8.41205 13.0015C8.44125 13.0005 8.47056 13 8.5 13H8.51426C8.55491 13 8.59145 12.9753 8.60702 12.9377C8.62261 12.9002 8.61423 12.8569 8.58546 12.8281L8.57538 12.818C8.55456 12.7972 8.53419 12.7761 8.51426 12.7548L8.5 12.7393C8.07934 12.281 7.86073 11.7038 7.84417 11.1218C7.84346 11.0971 7.84312 11.0723 7.84315 11.0476C7.84382 10.4087 8.0879 9.76997 8.57538 9.28249L9.28249 8.57538C9.76997 8.0879 10.4087 7.84382 11.0476 7.84315C11.0723 7.84312 11.0971 7.84346 11.1218 7.84417C11.7038 7.86073 12.281 8.07934 12.7393 8.5L12.7548 8.51426C12.7761 8.53419 12.7972 8.55456 12.818 8.57538L12.8281 8.58546C12.8569 8.61423 12.9002 8.62261 12.9377 8.60702C12.9753 8.59145 13 8.55491 13 8.51426V8.5C13 8.47056 13.0005 8.44124 13.0015 8.41205L13.0023 8.39107C13.029 7.76953 13.2826 7.20678 13.6823 6.78358C13.6993 6.76559 13.7166 6.74784 13.7341 6.73036C14.1864 6.27905 14.8106 6 15.5 6H16.5ZM15 23.5C15 23.7761 15.2239 24 15.5 24H16.5C16.7761 24 17 23.7761 17 23.5V23.4857C17 22.6262 17.5212 21.8669 18.2962 21.5455C19.0727 21.2235 19.9787 21.3929 20.5861 22.0003L20.5962 22.0104C20.7915 22.2057 21.108 22.2057 21.3033 22.0104L22.0104 21.3033C22.2057 21.108 22.2057 20.7915 22.0104 20.5962L22.0003 20.5861C21.3929 19.9787 21.2235 19.0727 21.5455 18.2961C21.8669 17.5212 22.6262 17 23.4857 17H23.5C23.7761 17 24 16.7761 24 16.5V15.5C24 15.2239 23.7761 15 23.5 15H23.4857C22.6262 15 21.8669 14.4788 21.5455 13.7039C21.2235 12.9273 21.3929 12.0213 22.0003 11.4139L22.0104 11.4038C22.2057 11.2085 22.2057 10.892 22.0104 10.6967L21.3033 9.98959C21.108 9.79433 20.7915 9.79433 20.5962 9.98959L20.5861 9.99968C19.9787 10.6071 19.0727 10.7765 18.2962 10.4545C17.5212 10.1331 17 9.37381 17 8.51426V8.5C17 8.22386 16.7761 8 16.5 8H15.5C15.2239 8 15 8.22386 15 8.5V8.51426C15 9.37381 14.4788 10.1331 13.7038 10.4545C12.9273 10.7765 12.0213 10.6071 11.4139 9.99968L11.4038 9.98959C11.2085 9.79433 10.892 9.79433 10.6967 9.98959L9.98959 10.6967C9.79433 10.892 9.79433 11.2085 9.98959 11.4038L9.99967 11.4139C10.6071 12.0213 10.7765 12.9273 10.4545 13.7039C10.1331 14.4788 9.37382 15 8.51426 15H8.5C8.22386 15 8 15.2239 8 15.5V16.5C8 16.7761 8.22386 17 8.5 17H8.51426C9.37382 17 10.1331 17.5212 10.4545 18.2961C10.7765 19.0727 10.6071 19.9787 9.99968 20.5861L9.98959 20.5962C9.79433 20.7915 9.79433 21.108 9.98959 21.3033L10.6967 22.0104C10.892 22.2057 11.2085 22.2057 11.4038 22.0104L11.4139 22.0003C12.0213 21.3929 12.9273 21.2235 13.7038 21.5455C14.4788 21.8669 15 22.6262 15 23.4857V23.5Z" fill={color ? color : "#B2B2CC"}/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z" fill={color ? color : "#B2B2CC"}/>
        </svg>
    )
}

function NavDashBoardIcon({height, width, fill, color}){
    return(
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.7483 13.3965L25.7485 13.3962L25.7424 13.3919L17.2484 7.33249C16.5095 6.76511 15.4887 6.76596 14.7512 7.27646C14.7512 7.27648 14.7511 7.27651 14.7511 7.27653L6.31017 13.0662L6.31016 13.0661L6.30861 13.0672C5.88992 13.3663 5.76279 13.9145 6.06892 14.3431C6.36798 14.7618 6.91616 14.8889 7.34474 14.5828L8.32295 13.884V20.3454C8.32295 22.8897 10.3698 24.9366 12.9142 24.9366H19.0828C21.6271 24.9366 23.674 22.8897 23.674 20.3454V14.1546L24.6522 14.8533L24.6522 14.8534L24.6549 14.8551C24.8303 14.9721 25.0116 15.0343 25.1973 15.0343C25.4994 15.0343 25.7454 14.9112 25.9267 14.6696L25.928 14.6677C26.2329 14.241 26.1079 13.6961 25.7483 13.3965ZM15.8382 8.74013L15.846 8.73482L15.8527 8.72812C15.9158 8.6651 16.0211 8.64895 16.1581 8.73972L21.8507 12.8212V20.3454C21.8507 21.8594 20.5968 23.1132 19.0828 23.1132H12.9142C11.4002 23.1132 10.1463 21.8594 10.1463 20.3454V12.6064L15.8382 8.74013Z" fill={color ? color :"#B2B2CC"} stroke="#B2B2CC" stroke-width="0.2"/>
      </svg>
    )
}

function NavAudienceIcon({height, width, fill}){
    return(
      <svg className="cp" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3652 5.14C16.3652 7.84068 14.1759 10.03 11.4752 10.03C8.77454 10.03 6.58521 7.84068 6.58521 5.14C6.58521 2.43933 8.77454 0.25 11.4752 0.25C14.1759 0.25 16.3652 2.43933 16.3652 5.14ZM14.7352 5.14C14.7352 6.94045 13.2757 8.40001 11.4752 8.40001C9.67476 8.40001 8.21521 6.94045 8.21521 5.14C8.21521 3.33955 9.67476 1.88 11.4752 1.88C13.2757 1.88 14.7352 3.33955 14.7352 5.14Z" fill="#B2B2CC"/>
        <path d="M5.93234 1.94505C6.37345 1.85551 6.65846 1.42533 6.56892 0.984212C6.47938 0.543096 6.04919 0.258089 5.60808 0.347631C3.3757 0.800779 1.6952 2.77314 1.6952 5.13983C1.6952 7.50652 3.3757 9.47888 5.60808 9.93203C6.04919 10.0216 6.47938 9.73656 6.56892 9.29545C6.65846 8.85433 6.37345 8.42415 5.93234 8.33461C4.44466 8.03262 3.3252 6.71604 3.3252 5.13983C3.3252 3.56362 4.44466 2.24704 5.93234 1.94505Z" fill="#B2B2CC"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.154 12.1274C8.15878 11.3562 9.55919 10.845 11.4752 10.845C13.3913 10.845 14.7917 11.3562 15.7965 12.1275C16.7938 12.893 17.3363 13.8646 17.6305 14.6825C17.8895 15.4025 17.708 16.1072 17.2738 16.6066C16.8544 17.089 16.2194 17.365 15.5502 17.365H7.40023C6.731 17.365 6.09604 17.089 5.67665 16.6066C5.24239 16.1072 5.06096 15.4024 5.31994 14.6825C5.61418 13.8646 6.15673 12.8929 7.154 12.1274ZM8.14651 13.4204C7.46016 13.9473 7.07294 14.6249 6.85373 15.2342C6.80798 15.3614 6.83315 15.4525 6.9067 15.5371C6.99513 15.6388 7.16923 15.735 7.40023 15.735H15.5502C15.7812 15.735 15.9553 15.6388 16.0437 15.5371C16.1173 15.4525 16.1425 15.3614 16.0967 15.2343C15.8775 14.6249 15.4903 13.9473 14.804 13.4204C14.1251 12.8994 13.0881 12.475 11.4752 12.475C9.86242 12.475 8.82535 12.8994 8.14651 13.4204Z" fill="#B2B2CC"/>
        <path d="M1.89971 15.1457C2.06654 14.5033 2.35289 13.8278 2.82545 13.323C3.27458 12.8432 3.92873 12.475 4.95521 12.475C5.40532 12.475 5.77021 12.1101 5.77021 11.66C5.77021 11.2099 5.40532 10.845 4.95521 10.845C3.47136 10.845 2.38839 11.4047 1.63547 12.209C0.90597 12.9883 0.525314 13.9532 0.322044 14.7359C-0.0717643 16.2523 1.21802 17.365 2.51018 17.365H3.1371C3.58721 17.365 3.9521 17.0001 3.9521 16.55C3.9521 16.0999 3.58721 15.735 3.1371 15.735H2.51018C2.27992 15.735 2.09655 15.6404 1.9923 15.5252C1.89788 15.4209 1.86032 15.2973 1.89971 15.1457Z" fill="#B2B2CC"/>
      </svg>

    )
}

function NavDashboardIcon() {
    return(
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.14373 19.0358V15.9689C7.14372 15.1918 7.77567 14.5604 8.55844 14.5555H11.4326C12.2189 14.5555 12.8563 15.1883 12.8563 15.9689V19.0269C12.8563 19.7009 13.404 20.2487 14.0829 20.2536H16.0438C16.9596 20.256 17.8388 19.8965 18.4872 19.2544C19.1356 18.6123 19.5 17.7404 19.5 16.8312V8.11951C19.5 7.38505 19.1721 6.68837 18.6046 6.21716L11.943 0.92793C10.7785 0.00278461 9.11537 0.0326703 7.98539 0.999046L1.46701 6.21716C0.872741 6.67448 0.517552 7.37322 0.5 8.11951V16.8223C0.5 18.7174 2.04738 20.2536 3.95617 20.2536H5.87229C6.19917 20.256 6.51349 20.1287 6.74547 19.9001C6.97746 19.6714 7.10793 19.3603 7.10792 19.0358H7.14373Z" fill="#A0A3BD"/>
        </svg>


    )
}

function NavCampaignIcon() {
    return(
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.58046e-05 7.29602C-0.00686438 7.90088 0.365988 8.44524 0.932476 8.65733V6.06528C0.932476 6.02798 0.951107 5.97205 0.951107 5.93475C0.3808 6.14513 0.00148784 6.6881 9.58046e-05 7.29602Z" fill="#AFAEAE"/>
            <path d="M5.09095 10.5035H2.64807L3.56182 13.8228C3.69713 14.3294 4.15636 14.6814 4.6807 14.6806C5.05376 14.6851 5.40673 14.512 5.63174 14.2144C5.85893 13.9313 5.929 13.5531 5.81821 13.2075L5.09095 10.5035Z" fill="#AFAEAE"/>
            <path d="M0.951111 5.91603H0.969743V5.8974C0.969743 5.91603 0.969743 5.91603 0.951111 5.91603Z" fill="#AFAEAE"/>
            <path d="M14.3217 5.65503H14.1725V9.01166H14.3217C15.2486 9.01166 16 8.26025 16 7.33336C16 6.40644 15.2486 5.65503 14.3217 5.65503Z" fill="#AFAEAE"/>
            <path d="M1.49194 6.06523V8.71325C1.51211 9.39899 2.07399 9.94431 2.75998 9.94402H6.15391V4.90906H2.75998C2.08866 4.90906 1.49194 5.39391 1.49194 6.06523Z" fill="#AFAEAE"/>
            <path opacity="0.9" d="M6.71332 10.0186L13.613 12.7785V2L6.71332 4.75991V10.0186Z" fill="#AFAEAE"/>
        </svg>  
    )
}

function NavGrowthIcon({width, height, icon}) {
    return(
        <svg width={(width) ? width : '20' } height={(height) ? height : '24'} viewBox="0 0 16 16" fill={(icon)? '#EB763C':'#AFAEAE'} xmlns="http://www.w3.org/2000/svg">
            <path d="M0 14.6663H16V15.9996H0V14.6663Z" fill={(icon)? '#EB763C':'#AFAEAE'}/>
            <path d="M14.4062 2.37346L14.6866 3.49496L15.9801 3.17163L15.3134 0.504962C15.2705 0.333454 15.1613 0.186001 15.0097 0.0950327C14.8581 0.00406478 14.6766 -0.0229685 14.5051 0.0198784L11.8384 0.686545L12.1617 1.98005L13.2412 1.71021C9.46342 7.17146 3.06025 8.66663 0 8.66663V9.99996C1.63642 9.99996 4.36158 9.56913 7.10242 8.35988C10.1846 6.99996 12.6346 4.98996 14.4062 2.37346Z" fill={(icon)? '#EB763C':'#AFAEAE'}/>
            <path d="M2.0001 10.6663C1.82329 10.6663 1.65372 10.7365 1.5287 10.8615C1.40367 10.9865 1.33344 11.1561 1.33344 11.3329V13.9996H5.33344V11.3329C5.33344 11.1561 5.2632 10.9865 5.13817 10.8615C5.01315 10.7365 4.84358 10.6663 4.66677 10.6663H2.0001Z" fill={(icon)? '#EB763C':'#AFAEAE'}/>
            <path d="M6.66667 9.33289C6.48986 9.33289 6.32029 9.40312 6.19526 9.52815C6.07024 9.65317 6 9.82274 6 9.99955V13.9996H10V9.99955C10 9.82274 9.92976 9.65317 9.80474 9.52815C9.67971 9.40312 9.51014 9.33289 9.33333 9.33289H6.66667Z" fill={(icon)? '#EB763C':'#AFAEAE'}/>
            <path d="M11.3332 6.66626C11.1564 6.66626 10.9869 6.7365 10.8618 6.86152C10.7368 6.98655 10.6666 7.15611 10.6666 7.33293V13.9996H14.6666V7.33293C14.6666 7.15611 14.5963 6.98655 14.4713 6.86152C14.3463 6.7365 14.1767 6.66626 13.9999 6.66626H11.3332Z" fill={(icon)? '#EB763C':'#AFAEAE'}/>
        </svg>
    )
}



function HeaderCollapseIcon({height, width, fill}){
    return (
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="12" height="1" rx="0.5" fill="black"/>
            <rect y="5" width="10" height="1" rx="0.5" fill="black"/>
            <rect y="10" width="12" height="1" rx="0.5" fill="black"/>
        </svg>
    )
}

function NavLoyatlyIcon(){
    return(
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.83789 11.7969H0.587891C0.264023 11.7969 0.00195312 12.0589 0.00195312 12.3828V19.4141C0.00195312 19.7379 0.264023 20 0.587891 20H1.83789C2.80719 20 3.5957 19.2115 3.5957 18.2422V13.5547C3.5957 12.5854 2.80723 11.7969 1.83789 11.7969Z" fill="#A0A3BD"/>
            <path d="M19.8261 12.9335C19.7558 12.8163 19.6621 12.7225 19.5566 12.6405C19.1252 12.2631 18.3982 12.2987 17.9746 12.7577L15.3144 15.828L15.2324 15.9217C14.9043 16.285 14.4355 16.4843 13.9434 16.4843H9.39648C9.06832 16.4843 8.81055 16.2264 8.81055 15.8983C8.81055 15.5702 9.06832 15.3124 9.39648 15.3124H12.9707C13.6152 15.3124 14.1426 14.7851 14.1426 14.1405V14.1288C14.1309 13.4843 13.6152 12.9686 12.9707 12.9686H10.8496C10.4982 12.9686 10.1216 12.8396 9.81836 12.5819C8.38871 11.328 6.30273 11.246 4.76758 12.3124V19.5194C5.92773 19.8358 7.12305 19.9999 8.33004 19.9999H13.5566C14.8457 19.9999 16.0645 19.3905 16.8379 18.3592L19.6504 14.6092C20.0607 14.0706 20.0916 13.3319 19.8261 12.9335Z" fill="#A0A3BD"/>
            <path d="M15.7133 1.13262C15.0634 0.402227 14.1625 0 13.1766 0C12.0761 0 11.1221 0.520352 10.4179 1.50477C10.3651 1.57855 10.3157 1.65238 10.2694 1.72543C10.2231 1.65234 10.1737 1.57855 10.1209 1.50477C9.41664 0.520352 8.4627 0 7.36223 0C6.37629 0 5.47539 0.402227 4.82555 1.13258C4.20883 1.8257 3.86914 2.7523 3.86914 3.74172C3.86914 4.81691 4.28637 5.80906 5.18207 6.86414C5.96367 7.78465 7.08473 8.73086 8.38277 9.82648C8.86246 10.2314 9.35852 10.65 9.88562 11.1069C9.99574 11.2023 10.1325 11.25 10.2694 11.25C10.4062 11.25 10.543 11.2023 10.6531 11.1069C11.1802 10.6501 11.6761 10.2315 12.1558 9.82668C12.9895 9.12301 13.7095 8.51535 14.3342 7.9259C15.5472 6.78145 16.6696 5.48242 16.6696 3.74176C16.6696 2.75234 16.33 1.82574 15.7133 1.13262Z" fill="#A0A3BD"/>
        </svg>

    )
}

function BackIcon(props){
    return(
        <svg width="18" height="12" viewBox="0 0 18 12" fill={props.color ? props.color : '#828282'} xmlns="http://www.w3.org/2000/svg">
        <path d="M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z" fill={props.color ? props.color : '#828282'} />
        </svg>

    )
}

function ColorselectIcon(){

    return(
        <svg width="20" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
        <path d="M7.88623 16.947C7.68923 16.9474 7.49409 16.9089 7.31201 16.8337C7.12993 16.7585 6.96449 16.6481 6.82518 16.5088L0.458916 10.1411C0.315482 10.0027 0.201036 9.83719 0.122256 9.65415C0.0434749 9.4711 0.00193725 9.2742 6.61615e-05 9.07493C-0.00180493 8.87567 0.036028 8.67802 0.111358 8.49353C0.186687 8.30904 0.298005 8.1414 0.438815 8.00039C0.579626 7.85938 0.747109 7.74782 0.931493 7.67223C1.11588 7.59664 1.31347 7.55853 1.51274 7.56012C1.71201 7.56171 1.90897 7.60297 2.09212 7.68149C2.27528 7.76001 2.44096 7.87422 2.5795 8.01746L7.88473 13.3227L17.4371 3.77328C17.7185 3.49168 18.1003 3.33339 18.4984 3.33325C18.8965 3.33311 19.2784 3.49112 19.56 3.77253C19.8416 4.05394 19.9999 4.43569 20 4.8338C20.0001 5.23191 19.8421 5.61377 19.5607 5.89537L8.94727 16.5088C8.80797 16.6481 8.64253 16.7585 8.46045 16.8337C8.27837 16.9089 8.08323 16.9474 7.88623 16.947Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
        </svg>
    )
}

function Link(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.914 16.16l-1.168 1.168a3.046 3.046 0 01-4.304-4.3L7.61 11.86a1.277 1.277 0 00-1.805-1.808L4.639 11.22a5.594 5.594 0 107.911 7.911l1.168-1.166a1.276 1.276 0 10-1.804-1.805z"
          fill="#42526E"
        />
        <path
          d="M12.787 9.179L9.18 12.787a1.275 1.275 0 001.803 1.804l3.609-3.608a1.275 1.275 0 00-1.804-1.804z"
          fill="#42526E"
        />
        <path
          d="M19.131 4.639a5.593 5.593 0 00-7.911 0l-1.168 1.166a1.276 1.276 0 001.804 1.805l1.168-1.168a3.047 3.047 0 014.304 4.3L16.16 11.91a1.278 1.278 0 001.805 1.808l1.166-1.168a5.594 5.594 0 000-7.911z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Phone(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20.242 18.858s-4.046 5.775-12.565-2.75C-.892 7.522 4.935 3.53 4.935 3.53a1.801 1.801 0 012.719.193l1.64 2.197a1.807 1.807 0 01-.168 2.36L7.682 9.729s0 1.277 2.551 3.831c2.551 2.555 3.827 2.555 3.827 2.555l1.444-1.447a1.802 1.802 0 012.358-.167l2.186 1.642a1.809 1.809 0 01.194 2.716z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Email(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.77 6.65A1.65 1.65 0 0019.12 5H4.65A1.65 1.65 0 003 6.65v10.304a1.65 1.65 0 001.65 1.65h14.47a1.65 1.65 0 001.65-1.65V6.65zm-9.347 6.528L6.427 8.422a.572.572 0 01.443-.979h10.034a.571.571 0 01.44.98l-5.038 4.756a.652.652 0 01-.883-.001z"
          fill={props.color ? props.color : "#42526E"}
        />
      </svg>
    );
  }

  function Code(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20.759 8.61V7.456a.797.797 0 00-.796-.795h-1.122a.795.795 0 01-.78-.951l.352-1.758a.796.796 0 00-.78-.953h-1.21a.794.794 0 00-.779.634l-.477 2.389a.795.795 0 01-.78.634h-2.61a.797.797 0 01-.78-.951l.352-1.753A.796.796 0 0010.57 3h-1.21a.795.795 0 00-.78.634l-.476 2.389a.795.795 0 01-.78.634H5.092a.795.795 0 00-.796.795v1.152a.794.794 0 00.796.794h1.365a.797.797 0 01.78.952l-.674 3.369a.794.794 0 01-.779.634H3.795a.795.795 0 00-.795.8v1.15a.795.795 0 00.795.796h1.123a.796.796 0 01.779.951l-.352 1.758a.795.795 0 00.78.952h1.21a.794.794 0 00.78-.634l.476-2.383a.795.795 0 01.78-.634h2.611a.797.797 0 01.78.951l-.353 1.759a.795.795 0 00.78.951h1.21a.795.795 0 00.78-.634l.476-2.382a.795.795 0 01.78-.635h2.054a.795.795 0 00.796-.795v-1.17a.793.793 0 00-.796-.796h-1.187a.797.797 0 01-.78-.952l.674-3.364a.794.794 0 01.778-.634h1.99a.795.795 0 00.795-.799zm-7.91 5.748h-2.611a.796.796 0 01-.78-.952l.673-3.364a.794.794 0 01.78-.634h2.61a.795.795 0 01.78.952l-.674 3.359a.794.794 0 01-.779.639z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Location(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.604 20.302c2.1-1.72 6.02-5.528 6.02-9.99a7.312 7.312 0 00-14.624 0c0 4.462 3.92 8.27 6.02 9.99a2.02 2.02 0 002.584 0zm-1.292-8.365a2.437 2.437 0 100-4.874 2.437 2.437 0 000 4.874z"
          fill="#42526E"
        />
      </svg>
    );
  }
  function Copy(props) {
    return (
      <svg
      className="cp"
        width={18}
        height={18}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          opacity={0.3}
          d="M5.923 5.183h8.144V15.55H5.923V5.183z"
          fill="#7A869A"
        />
        <path
          d="M11.846.74H2.961c-.814 0-1.48.667-1.48 1.481v10.366h1.48V2.22h8.885V.741zm2.222 2.962H5.923c-.814 0-1.48.666-1.48 1.48V15.55c0 .814.666 1.48 1.48 1.48h8.145c.814 0 1.48-.666 1.48-1.48V5.183c0-.815-.666-1.481-1.48-1.481zm0 11.847H5.923V5.183h8.145v10.366z"
          fill="#7A869A"
        />
      </svg>
    );
  }

  function Search(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        onClick= {props.onClick}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className="cp"
        onClick={props.onClick}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Dollar(props) {
    return (
      <svg
        width={8}
        height={13}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.378 8.312c0 .69-.257 1.307-.77 1.848-.504.541-1.213.85-2.128.924v1.134h-.784v-1.134c-.84-.065-1.526-.317-2.058-.756C1.106 9.88.84 9.297.84 8.578h1.358c.028.383.163.705.406.966.252.261.616.42 1.092.476V6.59c-.961-.215-1.615-.457-1.96-.728-.42-.336-.681-.695-.784-1.078A3.005 3.005 0 01.84 3.93c0-.756.257-1.381.77-1.876.513-.495 1.209-.775 2.086-.84V.08h.784v1.134c.784.065 1.419.313 1.904.742.485.42.77.985.854 1.694h-1.4c-.028-.308-.163-.588-.406-.84-.233-.252-.55-.42-.952-.504v3.36c1.167.243 1.932.56 2.296.952.401.43.602.994.602 1.694zM3.696 2.278c-.485.047-.877.205-1.176.476-.29.27-.434.64-.434 1.106 0 .467.135.817.406 1.05.28.224.681.41 1.204.56V2.278zm.784 7.742c.513-.065.915-.247 1.204-.546a1.55 1.55 0 00.448-1.12c0-.448-.145-.784-.434-1.008-.28-.233-.686-.42-1.218-.56v3.234z"
          fill="#091E42"
        />
      </svg>
    );
  }

  function More(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5 14a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM19 14a2 2 0 100-4 2 2 0 000 4z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function View(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 11.664c4.91 8.885 12.86 8.885 17.77 0-4.91-8.885-12.86-8.885-17.77 0zm8.885 2.729a2.728 2.728 0 110-5.457 2.728 2.728 0 010 5.457z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Info(props) {
    return (
      <svg
        width={20}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.167 14.166h1.667v-5H9.167v5zM10 1.666A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.334 14.6 18.334 10 14.6 1.667 10 1.667zm0 15A6.676 6.676 0 013.334 10 6.676 6.676 0 0110 3.333 6.676 6.676 0 0116.667 10 6.676 6.676 0 0110 16.666zM9.167 7.5h1.667V5.833H9.167V7.5z"
          fill="#DFE1E6"
        />
        <path
          d="M9.167 5.833h1.667V7.5H9.167V5.833zm0 3.334h1.667v5H9.167v-5z"
          fill="#DFE1E6"
        />
        <path
          d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.334 14.6 18.334 10 14.6 1.667 10 1.667zm0 15A6.676 6.676 0 013.334 10 6.676 6.676 0 0110 3.333 6.676 6.676 0 0116.667 10 6.676 6.676 0 0110 16.666z"
          fill="#DFE1E6"
        />
      </svg>
    );
  }

  function Confirm(props) {
    return (
      <svg
        width={25}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.5 10.676l7.482 6.547L21.27 6"
          stroke="#fff"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  function Star(props) {
    return (
      <svg
        width={25}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.437 3.666L15.66 8.36l4.556.483a1.166 1.166 0 01.618 2.069l-3.633 2.986 1.124 5.022a1.166 1.166 0 01-1.743 1.251l-4.2-2.555-4.205 2.554a1.167 1.167 0 01-1.743-1.252l1.128-5.02-3.632-2.986a1.166 1.166 0 01.619-2.065l4.554-.483 2.225-4.697a1.167 1.167 0 012.108 0z"
          fill="#2F80ED"
        />
      </svg>
    );
  }

  function Dropdown(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        className={props.className}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 10l-4 4-4-4"
          stroke="#42526E"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  function Currency(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.755 3H4.022A1.023 1.023 0 003 4.015V15.05a1.022 1.022 0 001.015 1.016h15.74a1.023 1.023 0 001.015-1.016V4.015A1.023 1.023 0 0019.755 3zm-1.016 8.731a3.505 3.505 0 00-2.299 2.298H7.342a3.506 3.506 0 00-2.3-2.298V7.338a3.506 3.506 0 002.3-2.297h9.087a3.503 3.503 0 002.299 2.297l.011 4.393z"
          fill="#42526E"
        />
        <path
          d="M11.885 6.808a2.538 2.538 0 00-2.276 2.726 2.538 2.538 0 002.276 2.731 2.538 2.538 0 002.276-2.731 2.538 2.538 0 00-2.276-2.726zM3 19.362a1.153 1.153 0 001.155 1.155h15.459a1.153 1.153 0 001.155-1.155v-.888H3v.888z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Timezone(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.53 14.733l-.344-.183a.635.635 0 01-.34-.488l-.116-.993a.952.952 0 00-.612-.78l-1.527-.569a.635.635 0 01-.366-.362L14.55 9.64a.809.809 0 01.635-1.097l1.178-.162a.958.958 0 00.646-.391l.543-.762a7.261 7.261 0 00-5.667-2.718h-.117l.254 1.381a.635.635 0 01-.508.742.668.668 0 01-.213 0 .85.85 0 00-.965.518l-.325.902a.634.634 0 01-.778.394l-.588-.176a.682.682 0 00-.508.036.969.969 0 00-.404 1.373l.649 1.066a.958.958 0 00.813.457h1.194c.1 0 .198.024.286.069l1.21.613a.635.635 0 01.343.486l.035.278a.876.876 0 00.381.618l.678.453a.807.807 0 01.132 1.234l-.971 1.003a.943.943 0 00-.235.415l-.72 2.665a7.27 7.27 0 007.002-4.304zm-9.997 3.604l.079-.642a1.216 1.216 0 00-.209-.84L7.22 15.152a.735.735 0 01.088-.943.471.471 0 00-.1-.744l-2.592-1.5a7.27 7.27 0 003.917 6.372zm3.352 2.433a8.885 8.885 0 110-17.77 8.885 8.885 0 010 17.77z"
          fill="#42526E"
        />
      </svg>
    );
  }

  function Camera(props) {
    return (
      <svg
        width={16}
        height={16}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.725 15.072H2.075a1.94 1.94 0 01-1.95-1.943V4.382a1.945 1.945 0 011.934-1.944h1.554L5.103.944c.3-.279.694-.437 1.104-.444h3.386c.41.01.804.17 1.104.45l1.493 1.494h1.555a1.945 1.945 0 011.929 1.938v8.757a1.944 1.944 0 01-1.95 1.934zM7.899 4.383a3.887 3.887 0 110 7.774 3.887 3.887 0 010-7.774zm0 5.832a1.945 1.945 0 10.003-3.89 1.945 1.945 0 00-.003 3.89z"
          fill="#fff"
        />
      </svg>
    );
  }

  function Close(props) {
    return (
      <svg
        width={16}
        height={16}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#prefix__clip0)">
          <path
            d="M.667.667L8 8m7.334 7.333L8 8m0 0L15.334.667.667 15.333"
            stroke="#42526E"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="prefix__clip0">
            <path fill="#fff" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }


  function SortIcon(props) {
    return (
      <svg
        width={18}
        height={18}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.706 2.571H7.564L9.635.5l2.071 2.071zM7.591 15.479h4.089l-2.045 2.045-2.044-2.045zM3.949 3.984L0 14.04h1.615l.807-2.15h4.484l.808 2.15h1.614L5.388 3.984h-1.44zm-.992 6.467L4.66 5.906l1.702 4.545H2.957zm9.442 2.194h5.371v1.395h-7.485v-1.132l5.195-7.511h-5.16V3.993h7.283v1.105L12.4 12.645z"
          fill="#42526E"
        />
      </svg>
    );
  }
  

  function Upload(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.855 16.596h4.284c.589 0 1.07-.482 1.07-1.071V10.17h1.704c.953 0 1.435-1.156.76-1.831l-4.916-4.916a1.066 1.066 0 00-1.51 0L6.331 8.34c-.674.675-.203 1.831.75 1.831h1.703v5.355c0 .59.482 1.071 1.07 1.071zM5.57 18.738h12.852c.589 0 1.07.482 1.07 1.07 0 .59-.481 1.072-1.07 1.072H5.57A1.074 1.074 0 014.5 19.809c0-.59.482-1.071 1.071-1.071z"
          fill="#fff"
        />
      </svg>
    );
  }

  function Filter(props) {
    return (
      <svg
        width={24}
        height={25}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.282 5.5h15.206a1.282 1.282 0 011.282 1.283v.508a1.28 1.28 0 01-1.28 1.28H4.28A1.28 1.28 0 013 7.29v-.508A1.282 1.282 0 014.282 5.5zM7.115 11.315h9.54a1.282 1.282 0 011.282 1.282v.507a1.28 1.28 0 01-1.28 1.282H7.113a1.28 1.28 0 01-1.281-1.282v-.507a1.282 1.282 0 011.282-1.282zM13.916 17.13H9.854a1.288 1.288 0 00-1.283 1.27v.515a1.284 1.284 0 001.283 1.286h4.062a1.283 1.283 0 001.283-1.282v-.517a1.288 1.288 0 00-1.283-1.271z"
          fill="#7A869A"
        />
      </svg>
    );
  }

  function GraphProgressIcon(props) {
    return (
      <svg
        width={12}
        height={13}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.894 4.194l3.602 3.464a1.114 1.114 0 01-.826 1.861H2.2a1.114 1.114 0 01-.825-1.858l3.602-3.463a1.295 1.295 0 011.916-.004z"
          fill="#6FCF97"
        />
      </svg>
    );
  }

  function AudienceInfo(props) {
    return (
      <svg
        width={16}
        height={17}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.923 2.5A5.925 5.925 0 002 8.423a5.926 5.926 0 005.923 5.924 5.926 5.926 0 005.924-5.924A5.926 5.926 0 007.923 2.5zm.593 8.885H7.33V7.831h1.185v3.554zm0-4.739H7.33V5.462h1.185v1.184z"
          fill="#DFE1E6"
        />
      </svg>
    );
  }


  function Calendar(props) {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.443 7.261a1.12 1.12 0 001.12-1.12V4.12a1.12 1.12 0 10-2.24 0v2.02a1.12 1.12 0 001.12 1.121zM16.328 7.261a1.12 1.12 0 001.12-1.12V4.12a1.12 1.12 0 00-2.24 0v2.02a1.119 1.119 0 001.12 1.121z"
          fill="#42526E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.08 4.498v1.847a2.86 2.86 0 01-2.468 2.895 2.752 2.752 0 01-3.035-2.738V4.945a.457.457 0 00-.457-.456h-2.47a.455.455 0 00-.456.456V6.34a2.86 2.86 0 01-2.467 2.9 2.752 2.752 0 01-3.035-2.739V4.498A1.777 1.777 0 003 6.266v12.44a1.777 1.777 0 001.777 1.776h14.216a1.777 1.777 0 001.777-1.777V6.266a1.777 1.777 0 00-1.69-1.768zm-1.483 12.037a1.085 1.085 0 01-1.082 1.081h-9.52a1.086 1.086 0 01-1.08-1.081V12.32A1.085 1.085 0 017 11.236h9.52a1.085 1.085 0 011.08 1.08l-.003 4.219z"
          fill="#42526E"
        />
      </svg>
    );
  }
  function ViewMoreIcon(props){
    return(
        <svg width="16" height="4" viewBox="0 0 16 4" fill={props.color ? props.color : 'none'} xmlns="http://www.w3.org/2000/svg">
        <path d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z"  fill={props.color ? props.color : 'none'} />
        </svg>
    )
}

function DeleteIcon({color, width, height}){
  return(
      <svg width={width || "14"} height={height || "18"} viewBox="0 0 14 18" fill={color || 'none'} xmlns="http://www.w3.org/2000/svg">
      <path d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V6C13 4.9 12.1 4 11 4H3C1.9 4 1 4.9 1 6V16ZM13 1H10.5L9.79 0.29C9.61 0.11 9.35 0 9.09 0H4.91C4.65 0 4.39 0.11 4.21 0.29L3.5 1H1C0.45 1 0 1.45 0 2C0 2.55 0.45 3 1 3H13C13.55 3 14 2.55 14 2C14 1.45 13.55 1 13 1Z" fill={color || 'none'}/>
      </svg>

  )

}
function EditIcon({width, height, color}) {
  return(
      <svg width={width ? width : "24"} height={height ? height : "24"} viewBox="0 0 24 24" fill={color || 'none'} xmlns="http://www.w3.org/2000/svg">
          <path d="M3 17.25V21H6.75L17.81 9.93997L14.06 6.18997L3 17.25ZM21.41 6.33997L17.66 2.58997L15.13 5.12997L18.88 8.87997L21.41 6.33997V6.33997Z" fill={color || 'none'}/>
      </svg>            
  )
}


function WalletlyLoaderIcon({height, width}){
  return(
      <svg width={width ? width : 300} height={height ? height : 300} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M38.4987 43.2152C36.4533 45.3253 36.7082 48.5915 37.7336 49.9495L37.7951 50.0147L37.8374 50.0507C37.9958 50.1787 39.5871 50.4109 40.8364 49.4067L46.3281 43.6489L45.9083 43.2157C44.8849 42.16 43.5446 41.6323 42.2033 41.6323C40.863 41.6323 39.5217 42.16 38.4982 43.2157L38.4987 43.2152Z" fill="#EFEFEF" />
          <path d="M54.9328 43.2558L54.644 43.5527L59.806 49.0311C58.4273 47.9242 57.1485 48.5059 57.1485 48.5059C56.8188 48.6154 56.4055 48.8695 56.1565 49.1265L50.5649 54.8848L52.6551 57.0363C53.5576 57.964 54.9515 58.0735 55.9725 57.3697C56.1127 57.2733 56.2461 57.1633 56.3701 57.0363L62.3514 50.8852C62.8544 50.3669 63.248 49.7547 63.5091 49.0842C64.2693 47.1391 63.8841 44.8319 62.3514 43.2558C61.3269 42.2029 59.9846 41.6758 58.6423 41.6758C57.3 41.6758 55.9573 42.2029 54.9328 43.2558Z" fill="#EFEFEF" />
          <path d="M48.8488 41.5978L41.0863 49.7334C40.304 50.3623 39.4439 50.4942 38.8598 50.4942C38.7698 50.4942 38.6798 50.4908 38.5917 50.4835L44.7333 56.8823C44.9467 57.1057 45.204 57.2836 45.4893 57.4052C45.7745 57.5268 46.0819 57.5896 46.3925 57.5896C47.0238 57.5896 47.6177 57.3355 48.0655 56.8741L55.8707 48.8329C56.1605 48.5325 56.5197 48.3062 56.9173 48.1733C57.3292 48.0376 57.7174 47.968 58.0722 47.968C58.1268 47.968 58.1804 47.9699 58.234 47.9728L52.2449 41.5915C52.0272 41.3638 51.7649 41.1823 51.474 41.0582C51.183 40.9341 50.8696 40.8699 50.5527 40.8696C49.9087 40.8696 49.303 41.1291 48.8483 41.5973L48.8488 41.5978Z" fill="#EFEFEF" />
          <path fillRule="evenodd" clipRule="evenodd" d="M50 21.25C34.1218 21.25 21.25 34.1218 21.25 50C21.25 65.8782 34.1218 78.75 50 78.75C65.8782 78.75 78.75 65.8782 78.75 50C78.75 34.1218 65.8782 21.25 50 21.25ZM50 20C33.4315 20 20 33.4315 20 50C20 66.5685 33.4315 80 50 80C66.5685 80 80 66.5685 80 50C80 33.4315 66.5685 20 50 20Z" fill="url(#paint0_linear)">
              <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
          </path>/&gt;
          <defs>
              <linearGradient id="paint0_linear" x1={80} y1={50} x2={20} y2={50} gradientUnits="userSpaceOnUse">
              <stop stopColor="#FEAC5E" />
              <stop offset="0.5" stopColor="#C779D0" />
              <stop offset={1} stopColor="#4BC0C8" />
              </linearGradient>
          </defs>
      </svg>

  )
}

function SelectedIcon(){
  return(
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#6FCF97"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3144 5.01909C12.4879 5.19266 12.4879 5.47406 12.3144 5.64763L6.98105 10.981C6.80748 11.1545 6.52607 11.1545 6.35251 10.981L3.68584 8.3143C3.51227 8.14073 3.51227 7.85932 3.68584 7.68576C3.85941 7.51219 4.14081 7.51219 4.31438 7.68576L6.66678 10.0382L11.6858 5.01909C11.8594 4.84552 12.1408 4.84552 12.3144 5.01909Z" fill="white"/>
    </svg>
  )
}

function GoToIcon(){
  return(
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 1C2 0.447715 2.44772 0 3 0L13 4.17233e-07C13.2652 4.76837e-07 13.5196 0.105357 13.7071 0.292894C13.8946 0.48043 14 0.734784 14 1L14 11C14 11.5523 13.5523 12 13 12C12.4477 12 12 11.5523 12 11L12 3.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L10.5858 2L3 2C2.44772 2 2 1.55228 2 1Z" fill="#2F80ED"/>
    </svg>

  )
}

function CopyIcon({className, color, height, width}) {
  return(
      <svg className={className + ' cp'} width={width ? width : "18"} height={height ? height : "18"} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.33333 5.33333H2.66666C1.93133 5.33333 1.33333 5.93133 1.33333 6.66666V13.3333C1.33333 14.0687 1.93133 14.6667 2.66666 14.6667H9.33333C10.0687 14.6667 10.6667 14.0687 10.6667 13.3333V6.66666C10.6667 5.93133 10.0687 5.33333 9.33333 5.33333Z" fill={color ? color : "#4F4F4F"}/>
      <path d="M13.3333 1.33333H6.66666C6.31304 1.33333 5.9739 1.4738 5.72385 1.72385C5.4738 1.9739 5.33333 2.31304 5.33333 2.66666V3.99999H10.6667C11.0203 3.99999 11.3594 4.14047 11.6095 4.39052C11.8595 4.64057 12 4.97971 12 5.33333V10.6667H13.3333C13.687 10.6667 14.0261 10.5262 14.2761 10.2761C14.5262 10.0261 14.6667 9.68695 14.6667 9.33333V2.66666C14.6667 2.31304 14.5262 1.9739 14.2761 1.72385C14.0261 1.4738 13.687 1.33333 13.3333 1.33333Z" fill={color ? color : "#4F4F4F"}/>
      </svg>
  )
}

function CrossIcon(){
  return(
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L12 12M20 20L12 12M12 12L20 4L4 20" stroke="#42526E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  )
}

function HelperTextIcon() {
  return(
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM8.66634 11.333H7.33301V9.99967H8.66634V11.333ZM8.66634 8.66634H7.33301V4.66634H8.66634V8.66634Z" fill="#D93025"/>
    </svg>
  )
}

function EyeIcon() {
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.28124 12C9.28124 12.6962 9.55781 13.3639 10.0501 13.8562C10.5424 14.3484 11.2101 14.625 11.9062 14.625C12.6024 14.625 13.2701 14.3484 13.7624 13.8562C14.2547 13.3639 14.5313 12.6962 14.5313 12C14.5313 11.3038 14.2547 10.6361 13.7624 10.1438C13.2701 9.65156 12.6024 9.375 11.9062 9.375C11.2101 9.375 10.5424 9.65156 10.0501 10.1438C9.55781 10.6361 9.28124 11.3038 9.28124 12V12ZM22.0828 11.3953C19.8609 6.71484 16.5023 4.35938 12 4.35938C7.4953 4.35938 4.13905 6.71484 1.91717 11.3977C1.82805 11.5864 1.78183 11.7925 1.78183 12.0012C1.78183 12.2099 1.82805 12.416 1.91717 12.6047C4.13905 17.2852 7.49765 19.6406 12 19.6406C16.5047 19.6406 19.8609 17.2852 22.0828 12.6023C22.2633 12.2227 22.2633 11.782 22.0828 11.3953V11.3953ZM11.9062 16.125C9.62812 16.125 7.78124 14.2781 7.78124 12C7.78124 9.72188 9.62812 7.875 11.9062 7.875C14.1844 7.875 16.0313 9.72188 16.0313 12C16.0313 14.2781 14.1844 16.125 11.9062 16.125Z" fill="#5F6368"/>
    </svg>
  )
}

function CrossEyeIcon() {
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9062 14.6241C12.6024 14.6241 13.2701 14.3475 13.7624 13.8552C14.2546 13.363 14.5312 12.6953 14.5312 11.9991C14.5312 11.9222 14.5277 11.846 14.5211 11.7708L11.6779 14.614C11.7532 14.6206 11.8291 14.6241 11.9062 14.6241ZM20.595 3.87941L19.5937 2.87909C19.5585 2.84396 19.5109 2.82422 19.4612 2.82422C19.4115 2.82422 19.3638 2.84396 19.3286 2.87909L16.7664 5.44198C15.353 4.71964 13.7642 4.35847 12 4.35847C7.49526 4.35847 4.13433 6.70456 1.91714 11.3967C1.82802 11.5855 1.7818 11.7916 1.7818 12.0003C1.7818 12.209 1.82802 12.4151 1.91714 12.6038C2.80308 14.4699 3.86987 15.9656 5.11753 17.0909L2.63808 19.5694C2.60294 19.6046 2.5832 19.6522 2.5832 19.7019C2.5832 19.7517 2.60294 19.7993 2.63808 19.8345L3.63862 20.835C3.67378 20.8702 3.72146 20.8899 3.77116 20.8899C3.82087 20.8899 3.86854 20.8702 3.9037 20.835L20.595 4.14472C20.6124 4.1273 20.6262 4.10662 20.6357 4.08386C20.6451 4.0611 20.6499 4.0367 20.6499 4.01206C20.6499 3.98742 20.6451 3.96302 20.6357 3.94026C20.6262 3.9175 20.6124 3.89682 20.595 3.87941ZM7.7812 11.9991C7.78114 11.2866 7.96562 10.5863 8.31667 9.96625C8.66773 9.34626 9.17339 8.82776 9.78439 8.46127C10.3954 8.09478 11.0909 7.8928 11.8032 7.875C12.5154 7.85721 13.2202 8.0242 13.8487 8.35972L12.7092 9.49925C12.2496 9.3521 11.7584 9.33438 11.2894 9.44803C10.8204 9.56168 10.3918 9.80231 10.0506 10.1435C9.70942 10.4847 9.46879 10.9133 9.35514 11.3823C9.24149 11.8513 9.25921 12.3425 9.40636 12.8021L8.26683 13.9416C7.94705 13.3441 7.78021 12.6768 7.7812 11.9991V11.9991Z" fill="#5F6368"/>
      <path d="M22.0828 11.3949C21.2578 9.65742 20.2759 8.24063 19.1369 7.14453L15.7587 10.523C16.0434 11.2675 16.1066 12.0784 15.9404 12.8579C15.7742 13.6374 15.3859 14.3521 14.8223 14.9157C14.2588 15.4793 13.544 15.8676 12.7645 16.0338C11.985 16.1999 11.1741 16.1368 10.4297 15.852L7.56421 18.7175C8.89358 19.3327 10.3722 19.6402 12 19.6402C16.5047 19.6402 19.8656 17.2941 22.0828 12.602C22.1719 12.4132 22.2182 12.2071 22.2182 11.9984C22.2182 11.7897 22.1719 11.5836 22.0828 11.3949V11.3949Z" fill="#5F6368"/>
    </svg>
  )
}

function RefreshIcon({height, width, color, className}) {
  return(
    <svg className={className||''} width={width||"24"} height={height||"24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.19824 10.2213C5.00661 6.65879 8.19401 4 12 4C14.9031 4 17.4466 5.5462 18.8492 7.8636L16.3054 7.04775C15.7795 6.87909 15.2164 7.16868 15.0478 7.69458C14.8791 8.22048 15.1687 8.78354 15.6946 8.9522L20.6946 10.5558C20.9988 10.6533 21.3313 10.5997 21.5893 10.4115C21.8474 10.2232 22 9.92299 22 9.60355V3.99998C22 3.44769 21.5523 2.99998 21 2.99998C20.4477 2.99998 20 3.44769 20 3.99998V5.99928C18.1764 3.57194 15.2724 2 12 2C7.23966 2 3.25836 5.32525 2.24782 9.77871C2.12561 10.3173 2.46315 10.853 3.00174 10.9752C3.54033 11.0974 4.07602 10.7599 4.19824 10.2213Z" fill={color||"#222222"}/>
    <path d="M21.7522 14.2213C21.8744 13.6827 21.5369 13.147 20.9983 13.0248C20.4597 12.9026 19.924 13.2401 19.8018 13.7787C18.9934 17.3412 15.806 20 12 20C9.06371 20 6.49525 18.4182 5.10306 16.0565L8.75746 16.9701C9.29326 17.1041 9.83619 16.7783 9.97014 16.2425C10.1041 15.7067 9.77833 15.1638 9.24253 15.0298L3.24253 13.5298C2.94379 13.4551 2.6273 13.5223 2.38459 13.7118C2.14187 13.9013 2 14.192 2 14.5V20C2 20.5523 2.44771 21 3 21C3.55228 21 4 20.5523 4 20L4 18.0007C5.82361 20.428 8.7276 22 12 22C16.7604 22 20.7417 18.6747 21.7522 14.2213Z" fill={color||"#222222"}/>
    </svg>
  )
}

const SvgIcons = {
    ViewMoreIcon,
    EyeIcon,
    CrossEyeIcon,
    DeleteIcon,
    HelperTextIcon,
    EditIcon,
    Camera,
    Calendar,
    Filter,
    Close,
    Upload,
    Currency,
    Timezone,
    Dropdown,  
    Star,
    Confirm,
    Info,
    Dollar,
    Search,
    NavSettingIcon,
    NavDashBoardIcon,
    NavAudienceIcon,
    HeaderCollapseIcon,
    NavGrowthIcon,
    NavCampaignIcon,
    NavDashboardIcon,
    NavLoyatlyIcon,
    BackIcon,
    ColorselectIcon,
    Link,
    Phone,
    Email,
    Code,
    Location,
    Copy,
    More,
    View,
    SortIcon,
    GraphProgressIcon,
    AudienceInfo,
    WalletlyLoaderIcon,
    SelectedIcon,
    GoToIcon,
    CopyIcon,
    CrossIcon,
    RefreshIcon
}


export default SvgIcons